<div id="content" *ngIf="showAppShell">
  <div class="desktop-view" *ngIf="!isMobile">
    <div class="visible-lg visible-md">
      <app-sidebar></app-sidebar>
    </div>
    <div [ngClass]="global.toggleSidemenu ? 'toggle-space' : 'nospace-toggle' "  [ngClass]="{'sidebar-transition': true}" class="page-wrapper">
      <app-header></app-header>
      <router-outlet></router-outlet>
    </div>
  </div>
  <div class="mobile-view" *ngIf="isMobile">
    <div [ngClass]="global.toggleSidemenu ? 'toggle-space' : 'nospace-toggle'" [ngClass]="{'sidebar-transition': true}" class="mobile-page-wrapper">
      <app-header-mobile></app-header-mobile>
      <router-outlet></router-outlet>
    </div>
  </div>
  <!-- <app-chat-widget></app-chat-widget> -->
</div>
<router-outlet *ngIf="!showAppShell"></router-outlet>
